<template>
      
      <!-- Begin page -->
      <div id="wrapper">
            
            <!-- Top Bar Start -->
            <topbar></topbar>
            <!-- Top Bar End -->
            
            
            <!-- ========== Left Sidebar Start ========== -->
            
            <!-- Left Sidebar End -->
            <left></left>
            
            
            <!-- ============================================================== -->
            <!-- Start right Content here -->
            <!-- ============================================================== -->
      
            <signup_result0 v-if="status==0"></signup_result0>
            <signup_result1 v-if="status==1"></signup_result1>
            <signup_result2 v-if="status==2"></signup_result2>
            <signup_result3 v-if="status==3"></signup_result3>
            
            <!-- ============================================================== -->
            <!-- End Right content here -->
            <!-- ============================================================== -->
      
      
      </div>
      <!-- END wrapper -->


</template>

<script>
      import topbar from './topbar';
      import left from './left';
      import Signup from "./signup";
      import signup_result0 from "./signup_result0";
      import signup_result1 from "./signup_result1";
      import signup_result2 from "./signup_result2";
      import signup_result3 from "./signup_result3";
      export default {
            name: 'main',
            components:{Signup, topbar,left,signup_result0,signup_result1,signup_result2,signup_result3},
            data() {
                  return {
                        status:0,
                  }
            },
            mounted(){
                  this.show();
            },
            methods: {
                  show: function () {
                        
                        this.$axios({
                              method: 'get',
                              url: '/api/member2/signup_result',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {

                              this.status = response.data.status;
                              
                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  //method over

            }
            //mounted over


      }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      .zx{width:100%;}
      .zx li{width:100%;float: left}

  
     
</style>



// WEBPACK FOOTER //
// src/components/signup_result.vue